import React from 'react';
import IconFromImage from '../IconFromImage/IconFromImage';
import funnelSrc from './assets/funnel.svg';

const FunnelIcon = () => (
    <IconFromImage type="funnel" src={funnelSrc} />
);

export default FunnelIcon;
